import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

// importing slick carousel css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ Import BrowserRouter
import { BrowserRouter } from "react-router-dom";
import { BalanceProvider } from "./pages/BalanceContext.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <BalanceProvider>
        <App />
      </BalanceProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
